import { ClientGetPromoteResponse } from "../../proto/ClientGetPromote_pb";

export const ADD_CLIENT_PROMOTE = "ADD_CLIENT_PROMOTE";

export type ClientPromoteType = ClientGetPromoteResponse.AsObject | undefined;

export type ClientPromoteStateType = {
  clientPromote: ClientPromoteType;
};

export type AddClientPromoteActionType = {
  type: typeof ADD_CLIENT_PROMOTE;
  payload: ClientPromoteType;
};

export type ClientPromoteActionTypes = AddClientPromoteActionType;
